import { Context, Effect, Layer } from 'effect'

export type BrowserCookiesService = {
  readonly read: Effect.Effect<string>
  readonly write: (assignment: string) => Effect.Effect<void>
}

export class BrowserCookies extends Context.Service<BrowserCookies, BrowserCookiesService>()(
  'BrowserCookies'
) {}

/** The only application boundary that reads or writes the browser cookie jar. */
export const browserCookiesLayer = Layer.succeed(BrowserCookies, {
  read: Effect.sync(() => document.cookie),
  write: (assignment) =>
    Effect.sync(() => {
      document.cookie = assignment
    })
})
